import { useCallback, useMemo } from 'react'
import { replace } from 'lib/routing/appRouting'
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'

export default function useGlobalSearchURLHashFilter() {
  const location = useAppSelector(state => state.router.location)
  const dispatch = useAppDispatch()
  const isFilterPanelOpen = useMemo(() => {
    if (location.hash.startsWith('#filter')) {
      return true
    }
    return false
  }, [location.hash])

  const toggleFilterPanel = useCallback((
  ) => {
    const search = location.search
    if (isFilterPanelOpen) {
      dispatch(replace({ hash: '', search }))
    } else {
      dispatch(replace({ hash: 'filter', search }))
    }
  }, [dispatch, isFilterPanelOpen, location])

  return { isFilterPanelOpen, toggleFilterPanel }
}
